export default "__VITE_ASSET__B08kdd9W__"